import Spinner from 'react-bootstrap/Spinner';
import { useMemo, useRef, useState } from 'react';
import { AppHeader } from '../App/AppHeader';
import { AppFooter } from '../App/AppFooter';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosDeleteWithHeader, axiosErrorHandler, axiosGetWithHeader, ShowAlertError } from '../Common/axios';
import Title, { Message, SingleButton } from '../Login/LoginUtil';
import { DeleteCancelButton } from './ClientUtil';
import { Button, Modal } from 'react-bootstrap';
import GLOBAL from '../Common/Util';

export function DeleteClient () {
    const {state} = useLocation();
    const runningId = state?state.runningId:null;
    const [spinner, setSpinner] = useState('Loading - Delete Client Page');
    const navigate = useNavigate();
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const handleDeleteClose = () => setShowDeleteAlert(false);
    const handleDeleteShow = () => setShowDeleteAlert(true);
    const closeReference = useRef();
  
    const [message, setMessage] = useState('');
    const [data, setData] = useState([]);
    const [success, setSuccess] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    useMemo(() => {
        axiosGetWithHeader("/user/"+runningId,
            (response)=>{
              setData(response.data);
              setSpinner(null);
            },
            (error)=>{
              console.log(error);
              setSpinner(null);
              setErrorAlert(error.message);
            }
          );
    }, [runningId]);

    const handleBack = (event) => {
      setTimeout(() => {
        navigate('/kpastro.html', { state:{runningId:data.runningId}, replace: true });
        navigate(0);
      }, 100);
    }

    const handleHome = (event) => {
      setTimeout(() => {
        navigate('/home.html', { replace: true });
      }, 100);
    }
    
    const handleSubmit =  () => {
        axiosDeleteWithHeader("/user/"+data.runningId,
            (response)=>{
              handleDeleteClose();
              setMessage(response.data.message);  
              GLOBAL.isLoading=false;
              setSuccess(true);
            },
            (error)=>{
                handleDeleteClose();
                setMessage(axiosErrorHandler(closeReference,error));
                setErrorAlert(error.message);
            }
        );
    }

    return (
        <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppHeader/>
            </div>    
        </div> 
        <div class="m-0 p-0 row align-items-top homepageheight overflow-auto">
            <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    

            <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
              <Title title="Delete Client" urlcallback={handleBack}></Title>
              <div class="row m-0 p-0 w-100 border rounded">
                <div class="col m-0 p-0 justify-content-center">
                <Message msg={message} />
                {success===false ? data!==null?
                <form method="post" onSubmit={handleSubmit}>
                  <div class="row m-0 p-0 w-100">
                  <div class="col-3 d-none d-lg-block"></div>
                  <div class="col-sm-12 col-lg-6 text-align-center">
                    <br/>
                    You have selected the client ( Id: <b>{data.runningId}</b>, Name : <b>{data.firstName} {data.lastName}</b> ) to delete.
                    <br/><br/>
                    If you delete the client, you will lose all of their information. 
                    <br/>
                    Click 'Delete' to proceed or 'Cancel' to keep the client details.
                    <br/>&nbsp;
                    </div>
                  </div>

                  <div class="card-body d-flex justify-content-center p-0 ">
                    <div class="w-50">
                      <DeleteCancelButton callback={handleDeleteShow} callbackCancel={handleBack} /> 
                    </div>
                  </div>  
                </form>
                :<></>:
                <div class="card-body d-flex justify-content-center p-0 pt-2 ">
                  <div class="w-50">
                    <SingleButton title="Ok" callback={handleHome}/>
                    </div>
                </div>  
                }
              </div>
            </div>
            </div>

            <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    

        </div>
        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppFooter/>
                <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
            </div>    
        </div> 
        <Modal centered backdrop="static" show={showDeleteAlert} onHide={handleDeleteClose}>
            <Modal.Header closeButton>
              <Modal.Title>Delete Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure to delete?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleSubmit}>Confirm</Button>
              <Button variant="primary" ref={closeReference}  onClick={handleDeleteClose}>Close</Button>
            </Modal.Footer>
          </Modal>
        </>
    );
}